import axiosInstance from './axiosInstance';

export interface RecommendStats {
  relateGamesCount: number;
  onlineGamesCount: number;
  coverage: number; // 覆盖率百分比
}

export interface RecommendConfig {
  similarity_threshold?: number;
  max_related_games?: number;
  use_desc?: boolean;
  use_tags?: boolean;
  use_categories?: boolean;
  desc_weight?: number;
  tags_weight?: number;
  categories_weight?: number;
  enable_diversity?: boolean;
  diversity_threshold?: number;
  enable_business_rules?: boolean;
}

export class RecommendApi {
  /**
   * 获取推荐管理统计信息
   */
  static async getStats(): Promise<RecommendStats> {
    const response = await axiosInstance.get('/cms/v1/recommend');
    return response.data.data;
  }

  /**
   * 运行游戏相关性计算脚本
   */
  static async calculateRelations(config?: RecommendConfig): Promise<{ success: boolean; message: string }> {
    const response = await axiosInstance.post('/cms/v1/recommend', config || {});
    return response.data.data;
  }
}
